import {
  ADMIN_AUTH_LOG_IN,
  ADMIN_AUTH_LOG_OUT,
  ADMIN_AUTH_REFRESH,
} from '../../actions/actionTypes';

const initialState = {
  isAdminAuthenticated: false,
  adminEmail: null,
  adminToken: null,
  payoutDashboardAccess: false,
};

const adminAuth = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_AUTH_LOG_IN:
      return {
        ...state,
        isAdminAuthenticated: true,
        adminEmail: action.payload.adminEmail,
        adminToken: action.payload.token,
        payoutDashboardAccess: action.payload.payoutDashboardAccess ?? false,
      };
    case ADMIN_AUTH_REFRESH:
      return {
        ...state,
        isAdminAuthenticated: true,
        adminToken: action.payload.token,
      };
    case ADMIN_AUTH_LOG_OUT:
      return initialState;
    default:
      return state;
  }
};

export default adminAuth;
